import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
  TemplateRef
} from '@angular/core';
import {NgClass, NgTemplateOutlet} from "@angular/common";
import {ButtonModule} from 'primeng/button';
import {ZTemplateDirective} from "@zaeper/angular-core-lib";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-info-card',
  templateUrl: 'info-card.component.html',
  imports: [
    NgClass,
    ButtonModule,
    NgTemplateOutlet,
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoCardComponent implements OnInit, AfterContentInit {
  @ContentChildren(ZTemplateDirective)
  private readonly _zTemplate!: QueryList<ZTemplateDirective>;

  @Input('splitBackground') splitBackground: boolean = false;
  @Input('backgroundImgSrc') backgroundImgSrc?: string;
  @Input('stretched') stretched: boolean = false;
  @Input('headline1') headline1: string = "";
  @Input('headline2') headline2: string = "";
  @Input('headline3') headline3: string = "";
  @Input('description') description: string = "";
  @Input('link') link: string = "";

  protected headerLeftTemplate: TemplateRef<ZTemplateDirective> | null = null;
  protected headerRightTemplate: TemplateRef<ZTemplateDirective> | null = null;
  protected centerTemplate: TemplateRef<ZTemplateDirective> | null = null;
  protected footerLeftTemplate: TemplateRef<ZTemplateDirective> | null = null;
  protected footerRightTemplate: TemplateRef<ZTemplateDirective> | null = null;

  constructor() {
  }

  ngAfterContentInit() {
    this._zTemplate.forEach((zTemplate: ZTemplateDirective) => {
      switch (zTemplate.getType()) {
        case 'headerLeft':
          this.headerLeftTemplate = zTemplate.template;
          break;
        case 'headerRight':
          this.headerRightTemplate = zTemplate.template;
          break;
        case 'center':
          this.centerTemplate = zTemplate.template;
          break;
        case 'footerLeft':
          this.footerLeftTemplate = zTemplate.template;
          break;
        case 'footerRight':
          this.footerRightTemplate = zTemplate.template;
          break;
        default:
          return;
      }
    });
  }

  ngOnInit() {
  }
}
